import { Outlet } from "react-router-dom";

export default function TagCategory() {
  return <Outlet />;
}
